import { Stack, Typography } from '@mui/material';
import React from 'react';

interface AddressProps {
  indent?: boolean;
  color?: string;
}

function Address({ indent, color }: AddressProps) {
  return (
    <Stack style={{ marginLeft: indent ? '20px' : '0px' }}>
      <Typography variant="caption" color={color}>
        Harmony Hill A Primitive Baptist Foundation
      </Typography>
      <Typography variant="caption" color={color}>
        104 Normandy
      </Typography>
      <Typography variant="caption" color={color}>
        Azle, TX 76020
      </Typography>
    </Stack>
  );
}

export default Address;
